//* 코치 공지사항 관련 API
//  2025.01.27
//  희문

import { get } from "api/Base.api";
import { INotice } from 'api/interfaces/bbs.interface';
import { IPagination } from 'api/interfaces/common.interface';

// 공지사항 목록 조회 응답 인터페이스
export interface INoticeListResponse {
    noticeList: INotice[];
    pagination: IPagination;
}

// 공지사항 상세 조회 응답 인터페이스
export interface INoticeDetailResponse {
    notice: INotice;
}

/**
 * 코치용 공지사항 목록 조회
 * @param page 페이지 번호 (기본값: 1)
 * @returns 공지사항 목록과 페이지네이션 정보
 */
export const getNoticeList = async (page: number = 1): Promise<INoticeListResponse> => {
    console.log('api/koach/v2/notice.api:getNoticeList', page);
    const response = await get(`/koach/v2/notice`, { page });
    return response;
};

/**
 * 코치용 공지사항 상세 조회
 * @param id 공지사항 ID
 * @returns 공지사항 상세 정보
 */
export const getNoticeDetail = async (id: number): Promise<INoticeDetailResponse> => {
    console.log('api/koach/v2/notice.api:getNoticeDetail', id);
    const response = await get(`/koach/v2/notice/${id}`);
    return response;
};
